// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"351":"0f702cc1","453":"b4b964e6","476":"7c88b4b1"}[chunkId] + ".chunk.js";
};